import { useHistoryStore } from './historyStore';
import { useQuery } from '@tanstack/react-query';
import { getHistoricEntries } from '../../services/predictorService';
import { isSuccess } from '../../common/serviceUtil';
import { UserContext } from '@incentivegames/ig-frontend-common/lib/contexts/userContext';
import { useContext } from 'react';
import { Entry } from '../../interfaces/predictors';
import { getEvents } from '../../services/sportService';
import { filterOutUndefinedValues } from '../../common/arrayUtils';
import { useTranslation } from 'react-i18next';

export const useShowModal = () => {
  const setOpen = useHistoryStore((s) => s.setOpen);
  return () => setOpen(true);
};
export const useHideModal = () => {
  const setOpen = useHistoryStore((s) => s.setOpen);
  return () => setOpen(false);
};

export const useGetHistoricEntries = () => {
  const { user } = useContext(UserContext);
  return useQuery(
    ['getHistoricEntries', user.token],
    ({ signal }) => getHistoricEntries({ userToken: user.token, signal }),
    {
      refetchOnWindowFocus: false,
      //this will store api call data for 10 minutes after all components using the data are unmounted
      staleTime: 1000 * 60 * 10,
    },
  );
};

export const useGetEntryEvents = (entry: Entry, enabled: boolean) => {
  const {
    i18n: { language },
  } = useTranslation();
  const eventIds = filterOutUndefinedValues(entry.picks.map((pick) => pick.eventId));
  const { data, status, isFetching } = useQuery(
    ['getHistoricEntries', eventIds],
    ({ signal }) => getEvents({ eventIds, signal, marketCode: undefined, languageCode: language }),
    {
      enabled,
      //this will store api call data for 10 minutes after all components using the data are unmounted
      staleTime: 1000 * 60 * 10,
    },
  );
  const events = isSuccess(data) ? data.value.events : undefined;
  return { events, status, isFetching };
};
